import React from "react";
import ReactDOM from "react-dom/client";
import { HashRouter as Router, Routes, Route, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./i18n";
import "./index.css";
import FooterInfo from './components/FooterInfo';

// 頁面組件
import Home from "./pages/Home";
import DiseaseAndTreatment from "./pages/disease-and-treatment";
import Nutrition from "./pages/nutrition";
import Vaccination from "./pages/vaccination";
import PulmonaryRehabilitation from "./pages/pulmonary-rehabilitation";
import OxygenTherapy from "./pages/oxygen-therapy";
import SmokingCessationAndScreening from "./pages/smoking-cessation-and-screening/index";
import NotFound from "./pages/NotFound";

// 合併LogoBar與Navigation
const HeaderBar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false);
  const { t, i18n } = useTranslation();

  // 控制背景滾動 (iOS 兼容版本)
  React.useEffect(() => {
    if (isMobileMenuOpen) {
      // 保存當前滾動位置
      const scrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';
    } else {
      // 恢復滾動位置
      const scrollY = document.body.style.top;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, parseInt(scrollY || '0') * -1);
    }
    return () => {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
    };
  }, [isMobileMenuOpen]);

  // 手機版全螢幕選單內容
  const mobileMenu = (
    <div
      className={`fixed inset-0 z-50 bg-green-800/80 backdrop-blur-md transition-all duration-200 ${
        isMobileMenuOpen ? "block" : "hidden"
      }`}
    >
      <div className="flex flex-col h-full">
        <div className="flex justify-end p-4">
          <button
            onClick={() => setIsMobileMenuOpen(false)}
            className="p-2 rounded hover:bg-green-700"
          >
            <svg
              className="h-8 w-8"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
        <nav className="flex-1 flex flex-col items-center justify-center space-y-6">
          <div className="w-full flex flex-col items-center">
            <Link
              to="./"
              onClick={() => setIsMobileMenuOpen(false)}
              className="w-11/12 text-white font-bold flex items-center justify-between hover:text-green-200 transition my-2 text-3xl"
            >
              {t("common.home")}
            </Link>
          </div>
          <div className="w-full flex flex-col items-center">
            <Link
              to="/disease-and-treatment"
              onClick={() => setIsMobileMenuOpen(false)}
              className="w-11/12 text-white font-bold flex items-center justify-between hover:text-green-200 transition my-2 text-3xl"
            >
              疾病認識與治療
            </Link>
          </div>
          <div className="w-full flex flex-col items-center">
            <Link
              to="/nutrition"
              onClick={() => setIsMobileMenuOpen(false)}
              className="w-11/12 text-white font-bold flex items-center justify-between hover:text-green-200 transition my-2 text-3xl"
            >
              營養照護與建議
            </Link>
          </div>
          <div className="w-full flex flex-col items-center">
            <Link
              to="/smoking-cessation-and-screening"
              onClick={() => setIsMobileMenuOpen(false)}
              className="w-11/12 text-white font-bold flex items-center justify-between hover:text-green-200 transition my-2 text-3xl"
            >
              戒菸與低劑量電腦斷層篩檢
            </Link>
          </div>
          <div className="w-full flex flex-col items-center">
            <Link
              to="/vaccination"
              onClick={() => setIsMobileMenuOpen(false)}
              className="w-11/12 text-white font-bold flex items-center justify-between hover:text-green-200 transition my-2 text-3xl"
            >
              疫苗注射建議
            </Link>
          </div>
          <div className="w-full flex flex-col items-center">
            <Link
              to="/pulmonary-rehabilitation"
              onClick={() => setIsMobileMenuOpen(false)}
              className="w-11/12 text-white font-bold flex items-center justify-between hover:text-green-200 transition my-2 text-3xl"
            >
              肺復原與居家運動
            </Link>
          </div>
          <div className="w-full flex flex-col items-center">
            <Link
              to="/oxygen-therapy"
              onClick={() => setIsMobileMenuOpen(false)}
              className="w-11/12 text-white font-bold flex items-center justify-between hover:text-green-200 transition my-2 text-3xl"
            >
              氧氣治療
            </Link>
          </div>
          <div className="w-full flex flex-col items-center">
            <Link
              to="/comorbidity-management"
              onClick={() => setIsMobileMenuOpen(false)}
              className="w-11/12 text-white font-bold flex items-center justify-between hover:text-green-200 transition my-2 text-3xl"
            >
              共病管理
            </Link>
          </div>
          {/* 語言切換 */}
          <div className="flex space-x-4 pt-8">
            <button
              onClick={() => {
                i18n.changeLanguage("zh-TW");
                setIsMobileMenuOpen(false);
              }}
              className={`px-6 py-3 font-bold transition text-2xl ${
                i18n.language === "zh-TW"
                  ? "text-green-200 underline"
                  : "text-white hover:text-green-200"
              }`}
            >
              繁體中文
            </button>
            {/* <button
              onClick={() => {
                i18n.changeLanguage("en");
                setIsMobileMenuOpen(false);
              }}
              className={`px-6 py-3 font-bold transition text-2xl ${
                i18n.language === "en"
                  ? "text-green-200 underline"
                  : "text-white hover:text-green-200"
              }`}
            >
              English
            </button> */}
          </div>
        </nav>
      </div>
    </div>
  );

  return (
    <div className="bg-white flex items-center justify-between px-4 py-2 shadow-md relative">
      <a href="./index.html" className="flex items-center">
        <img
          src="./logo.jpg"
          alt="logo"
          className="h-12 w-12 mr-4 rounded-full border"
        />
        <div>
          <div className="text-2xl font-bold text-green-900">
            COPD健康宣導網站
          </div>
          <div className="text-xs text-gray-500">Health Education for COPD</div>
        </div>
      </a>
      {/* 桌面版nav */}
      <div className="hidden xl:flex items-center space-x-6">
        <Navigation inline />
      </div>
      {/* 手機版menu按鈕 */}
      <div className="xl:hidden flex items-center">
        <button
          onClick={() => setIsMobileMenuOpen(true)}
          className="p-2 rounded bg-green-800 text-white hover:bg-green-700 focus:outline-none"
        >
          <svg
            className="h-8 w-8"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
        </button>
      </div>
      {mobileMenu}
    </div>
  );
};

// 語言切換組件
const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation();
  const [isOpen, setIsOpen] = React.useState(false);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setIsOpen(false);
    window.location.reload();
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-1 px-3 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 font-semibold transition-colors duration-200"
      >
        <span>{t("common.language")}</span>
        <svg
          className="w-4 h-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>
      {isOpen && (
        <div className="absolute right-0 mt-2 w-32 bg-white rounded-md shadow-lg py-1 z-10 border border-green-200">
          <button
            onClick={() => changeLanguage("zh-TW")}
            className={`block w-full text-left px-4 py-2 text-sm font-medium
              ${
                i18n.language === "zh-TW"
                  ? "bg-green-600 text-white"
                  : "text-gray-700 hover:bg-green-50"
              }`}
          >
            {t("common.zh")}
          </button>
          {/* <button
            onClick={() => changeLanguage("en")}
            className={`block w-full text-left px-4 py-2 text-sm font-medium
              ${
                i18n.language === "en"
                  ? "bg-green-600 text-white"
                  : "text-gray-700 hover:bg-green-50"
              }`}
          >
            {t("common.en")}
          </button> */}
        </div>
      )}
    </div>
  );
};

// 修改Navigation支援inline顯示
const Navigation = ({ inline = false }) => {
  const { t } = useTranslation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false);


  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };


  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest(".mobile-menu") &&
        !event.target.closest(".mobile-menu-button")
      ) {
        setIsMobileMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  React.useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isMobileMenuOpen]);

  // navigation menu item
  const NavItem = ({ to, children, className = "" }) => (
    <Link
      to={to}
      className={`font-semibold transition-colors duration-200 ${className} md:hover:text-green-700`}
    >
      {children}
    </Link>
  );

  return (
    <nav
      className={
        inline
          ? "flex items-center space-x-6"
          : "bg-green-800 text-white px-4 py-2 relative"
      }
    >
      {/* desktop menu */}
      {inline ? (
        <>
          <NavItem to="/">{t("common.home")}</NavItem>
          <NavItem to="/disease-and-treatment">疾病認識與治療</NavItem>
          <NavItem to="/nutrition">營養照護與建議</NavItem>
          <NavItem to="/smoking-cessation-and-screening">戒菸與低劑量電腦斷層篩檢</NavItem>
          <NavItem to="/vaccination">疫苗注射建議</NavItem>
          <NavItem to="/pulmonary-rehabilitation">肺復原與居家運動</NavItem>
          <NavItem to="/oxygen-therapy">氧氣治療</NavItem>
          <NavItem to="/comorbidity-management">共病管理</NavItem>
          <LanguageSwitcher />
        </>
      ) : (
        <div className="hidden md:flex items-center justify-between">
          <div className="flex items-center space-x-6">
            <NavItem to="./index.html">{t("common.home")}</NavItem>
            <NavItem to="/disease-and-treatment">疾病認識與治療</NavItem>
            <NavItem to="/nutrition">營養照護與建議</NavItem>
            {/* <DropdownMenu
              title="戒菸與低劑量電腦斷層篩檢"
              menuName="smoking"
              items={[
                { to: "/smoking-cessation-and-screening", label: "戒菸與低劑量電腦斷層篩檢" },
              ]}
            />
            <DropdownMenu
              title="健康照護"
              menuName="healthcare"
              items={[
                { to: "/vaccination", label: "疫苗注射建議" },
                { to: "/pulmonary-rehabilitation", label: "肺復原與居家運動" },
                { to: "/oxygen-therapy", label: "氧氣治療" },
                { to: "/comorbidity-management", label: "共病管理" },
              ]}
            /> */}
          </div>
          <LanguageSwitcher />
        </div>
      )}
      {/* mobile menu button */}
      {!inline && (
        <>
          <button
            onClick={toggleMobileMenu}
            className="mobile-menu-button p-2 rounded-md hover:bg-green-700 focus:outline-none"
          >
            <svg
              className="h-6 w-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              {isMobileMenuOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>
          <LanguageSwitcher />
        </>
      )}
      {/* mobile menu */}
      {/* {!inline && (
        <div
          className={`mobile-menu md:hidden absolute top-full left-0 right-0 z-50 bg-green-800 transition-all duration-200 ease-in-out
            ${
              isMobileMenuOpen
                ? "block opacity-100 translate-y-0"
                : "hidden opacity-0 -translate-y-4"
            }
          `}
        >
          <div className="px-2 pt-2 pb-3 space-y-1">
            <NavItem to="./index.html" className="block py-2">
              {t("common.home")}
            </NavItem>
            <NavItem to="/disease-and-treatment" className="block py-2">
              疾病認識與治療
            </NavItem>
            <NavItem to="/nutrition" className="block py-2">
              營養照護與建議
            </NavItem>
            <MobileDropdownMenu
              title="戒菸與低劑量電腦斷層篩檢"
              menuName="smoking"
              items={[
                { to: "/smoking-cessation-and-screening", label: "戒菸與低劑量電腦斷層篩檢" },
              ]}
            />
            <MobileDropdownMenu
              title="健康照護"
              menuName="healthcare"
              items={[
                { to: "/vaccination", label: "疫苗注射建議" },
                { to: "/pulmonary-rehabilitation", label: "肺復原與居家運動" },
                { to: "/oxygen-therapy", label: "氧氣治療" },
                { to: "/comorbidity-management", label: "共病管理" },
              ]}
            />
          </div>
        </div>
      )} */}
    </nav>
  );
};

// 右下角回到最上面按鈕，滾動才顯示
const BackToTopButton = () => {
  const [show, setShow] = React.useState(false);
  React.useEffect(() => {
    const onScroll = () => {
      setShow(window.scrollY > 100);
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  if (!show) return null;
  return (
    <button
      className="fixed bottom-6 right-6 bg-green-600 text-white rounded-full p-4 shadow-lg hover:bg-green-700 z-50 transition"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      title="回到最上面"
      aria-label="回到最上面"
    >
      <svg
        className="w-8 h-8"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 15l7-7 7 7"
        />
      </svg>
    </button>
  );
};

// 主應用組件
const App = () => (
  <Router>
    <div className="bg-green-50 min-h-screen">
      <HeaderBar />
      <BackToTopButton />
      <main className="max-w-5xl mx-auto py-8 px-2 md:px-0">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route
            path="/disease-and-treatment"
            element={<DiseaseAndTreatment />}
          />
          <Route path="/nutrition" element={<Nutrition />} />
          <Route path="/vaccination" element={<Vaccination />} />
          <Route
            path="/pulmonary-rehabilitation"
            element={<PulmonaryRehabilitation />}
          />
          <Route path="/oxygen-therapy" element={<OxygenTherapy />} />
          {/* <Route
            path="/comorbidity-management"
            element={<ComorbidityManagement />}
          /> */}
          <Route
            path="/smoking-cessation-and-screening"
            element={<SmokingCessationAndScreening />}
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <FooterInfo />
    </div>
  </Router>
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
